module.exports = __webpack_public_path__ + "img/bbva.23ee6492.svg";